import {
  CLEAN_FLOWS_VINCULATION_FILTER,
  CLEAN_FLOWS_VINCULATION_FILTER_ERROR,
  CLEAN_STATUS_VINCULATION_FILTER,
  CLEAN_STATUS_VINCULATION_FILTER_ERROR,
  CLEAN_TYPE_VINCULATION_FILTER,
  CLEAN_TYPE_VINCULATION_FILTER_ERROR,
  FLOWS_VINCULATION_FILTER,
  FLOWS_VINCULATION_FILTER_ERROR,
  STATUS_VINCULATION_FILTER,
  STATUS_VINCULATION_FILTER_ERROR,
  TYPE_VINCULATION_FILTER,
  TYPE_VINCULATION_FILTER_ERROR,
} from '_models/redux/types';

const initialFlowsState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export function flowsVinculationFilterReducer(state = initialFlowsState, action) {
  switch (action.type) {
    case FLOWS_VINCULATION_FILTER:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };
    case FLOWS_VINCULATION_FILTER_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };
    case CLEAN_FLOWS_VINCULATION_FILTER:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };
    case CLEAN_FLOWS_VINCULATION_FILTER_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}

const initialStatusState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export function statusVinculationFilterReducer(state = initialStatusState, action) {
  switch (action.type) {
    case STATUS_VINCULATION_FILTER:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };
    case STATUS_VINCULATION_FILTER_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };
    case CLEAN_STATUS_VINCULATION_FILTER:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };
    case CLEAN_STATUS_VINCULATION_FILTER_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}

const initialTypeState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export function typeVinculationFilterReducer(state = initialTypeState, action) {
  switch (action.type) {
    case TYPE_VINCULATION_FILTER:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };
    case TYPE_VINCULATION_FILTER_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };
    case CLEAN_TYPE_VINCULATION_FILTER:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };
    case CLEAN_TYPE_VINCULATION_FILTER_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
